import { render, staticRenderFns } from "./contactos.vue?vue&type=template&id=45bb4382&scoped=true"
import script from "./contactos.vue?vue&type=script&lang=js"
export * from "./contactos.vue?vue&type=script&lang=js"
import style0 from "./contactos.vue?vue&type=style&index=0&id=45bb4382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb4382",
  null
  
)

export default component.exports